import { GenericProvider, Provider } from "@/services/data/generic-provider";
import { baseAPIUrl } from "@/services/utils/utils";

interface ISdgReport {
  ratings: {
    impact_rating: number;
    impact_score: number;
    impact_positive: number;
    impact_negative: number;
    updated_at: string;
  };
  report: {
    report_date: string;
    report_type: string;
    report_pdf_url: string;
  };
  impact_scores: {
    sdg_target: number;
    impact_net: number;
    impact_positive: number;
    impact_negative: number;
  }[];
}

@Provider(`${baseAPIUrl}/sdg/report`)
class SdgReportProvider extends GenericProvider<ISdgReport> {
  public async getReport(companyId: number): Promise<ISdgReport> {
    const url = this.buildEndPointUrl({
      companyId,
      type: "company",
    });
    const request = this.httpClient.get(url);
    const { data } = await this.wrapRequest(request);
    return data;
  }
}

export const sdgReportProvider = new SdgReportProvider();
